export default __webpack_public_path__ + "static/bidra-i-figma2-4d54a5a70234f76fddf509ad0cceec62.png";